module.exports = __webpack_public_path__ + "img/zlzq.fbea0c0.png";